// extracted by mini-css-extract-plugin
export default {"customTagStatus":"CustomStatusTag_customTagStatus__Q3cDy","statusDot":"CustomStatusTag_statusDot__fqj8q","statusText":"CustomStatusTag_statusText__7M-N2"};